// extracted by css-extract-rspack-plugin
var _1 = "description-BLxNbY";
var _2 = "modelGroupStart-bOD2UY";
var _3 = "noTier-iHVSVo";
var _4 = "price-GVB9SK";
var _5 = "serviceTier-bu6EZP";
var _6 = "table-Bcf82A";
export { _1 as "description", _2 as "modelGroupStart", _3 as "noTier", _4 as "price", _5 as "serviceTier", _6 as "table" }
